import React, { useEffect, useState } from 'react';
import Drawer from 'react-modern-drawer';
import AssetLinkingServices from './AssetLinkingServices';
import TooltipList from '../Common/tooltip';
import Pagination from '../Header/Pagination';
export default function AssetLinkingFlyout(param: any) {

    const [isOpen, setIsOpen] = React.useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [searchValue, setSearchValue] = useState("");
    const [projectAsset, initProjectAsset] = useState<any[]>([]);

    const toggleDrawer = () => {
        setIsOpen(!isOpen)
        if (isOpen === true) {
            param.onClose("Close");
        }
    }

    const Data: any = {
        ProjectId: param.data.projectId,
        export: 0,
        type: "contract",
        pageNumber: 1,
        pageSize: 10
    }

    var saveObj = {
        assetCode: [[]],
        assetType: "",
        projectId: param.data.projectId
    }

    var saveObjK = {
        kontactCode: "",
        assetType: "",
        projectId: param.data.projectId
    }

    const getAssetList = () => {
        Data.type = param.showtab == 1 ? "contract" : param.showtab == 3 ? "song" : param.showtab == 4 ? "release" : param.showtab == 2 ? "track" : "";
        var dataLink = 'projectId=' + Data.ProjectId + '&type=' + Data.type + '&pageNumber=' + Data.pageNumber + '&pageSize=' + Data.pageSize;
        if (Data.searchFor) {
            dataLink = dataLink + '&searchFor=' + Data.searchFor;
        }

        AssetLinkingServices.projectAssetList(dataLink)
            .then((res) => {
                initProjectAsset(res);
                if (res[0].totalRows) {
                    setTotalRows(res[0].totalRows)
                } else {
                    setTotalRows(0)
                }

            })
    }

    const linkByContact = () => {
        AssetLinkingServices.linkProjectContractByContact(saveObjK)
            .then()
    }

    const saveAsset = (event: any) => {
        if (event == "All") {
            AssetLinkingServices.saveProjectAssets(saveObj).then((res) => { getAssetList(); })
        } else {
            AssetLinkingServices.projectAssetSave(saveObj).then((res) => { getAssetList(); })
        }
    }

    const toLinked = (value: any, btnNum: any) => {
        var dataLink = "";
        //link asset     
        if (btnNum === 1) {
            if (param.showtab === 4) {
                saveObj.assetCode = value.releaseBarcode;
                saveObj.assetType = "release";
            } else if (param.showtab === 2) {
                saveObj.assetCode = value.code;
                saveObj.assetType = "track";
            } else if (param.showtab === 3) {
                saveObj.assetCode = value.code;
                saveObj.assetType = "song";
            } else if (param.showtab === 1) {
                saveObj.assetCode = value.code;
                saveObj.assetType = "contract";
            }

            saveAsset("");
            //link contract   
        } else if (btnNum === 2) {
            if (param.showtab === 1) {
                saveObjK.kontactCode = value.contractArtistCode;
                saveObjK.assetType = "contract";
            }

            linkByContact();
            //Add all
        } else if (btnNum === 3) {
            var codeList: any[] = [];
            value.map((post: any) => {
                codeList.push(post.code);
            })

            saveObj.assetCode = (codeList);

            if (param.showtab === 4) {
                saveObj.assetType = "release";
                dataLink = 'projectId=' + Data.ProjectId + "&kontactCode=" + value.contractArtistCode + "&assetType=contract";
                AssetLinkingServices.addTracksToProject(dataLink)
            }
            else if (param.showtab === 2) { saveObj.assetType = "track"; }
            else if (param.showtab === 3) { saveObj.assetType = "song"; }
            else if (param.showtab === 1) { saveObj.assetType = "contract"; }

            saveAsset("All");
        }
    }

    const handleNameOnChange = (n: any) => {
        Data.pageNumber = n.pageNumber;
        Data.pageSize = n.pageSize;
        //dataLink = 'pageSize=' + Data.pageSize +'&pageNumber=' + Data.pageNumber;
        getAssetList();
    }

    return (
        <>
            <div className="ws-6">
                <button className="icon-btn edit pull-right" onClick={() => (setIsOpen(!isOpen), getAssetList())}>
                    <i className="icon-link"></i>
                    Link {param.showtab == 1 ? " Contract" : param.showtab == 3 ? " Songs" : param.showtab == 4 ? " Release" : param.showtab == 2 ? " Tracks" : ""}
                </button>
            </div>

            <Drawer open={isOpen} direction='right' className='react-drawer allowHscroll' size={800}>

                <>
                    <div className="ws-12 bg-blue">
                        <h1 className="mlxl pull-left text-center">
                            Link {param.showtab == 1 ? " Contract" : param.showtab == 3 ? " Songs" : param.showtab == 4 ? " Release" : param.showtab == 2 ? " Tracks" : ""}
                        </h1>
                        <i className="icon-close pull-right pLarge" onClick={() => setIsOpen(!isOpen)}></i>
                    </div>

                    <div className="box-content border-bottom">

                        <div className="ws-12 mtl mbxl">
                            <h2 className="mb">Filter contract list</h2>

                            <div className="ws-8">
                                <button className="icon-btn edit m0 w-10 pull-right" onClick={() => { Data.searchFor = searchValue; getAssetList(); }}>
                                    <i className="icon-search m0 p0"></i></button>
                                <input type="text" className="w-89 m0 heightReset noBorderRadius" onChange={(e) => setSearchValue(e.target.value)}
                                    onKeyDown={(e) => { if (e.code === "Enter") { Data.searchFor = searchValue; getAssetList(); } }} />
                            </div>

                            <div className="ws-4 mtll pl">
                                <button className="icon-btn edit m0" onClick={() => { toLinked(projectAsset, 3); }}><i className="icon-plus pull-right"></i>Add all
                                    Link {param.showtab == 1 ? " Contract" : param.showtab == 3 ? " Songs" : param.showtab == 4 ? " Release" : param.showtab == 2 ? " Tracks" : ""}
                                </button>
                            </div>
                        </div>

                    </div>

                    <div className="ws-12 text-bold mll"> Showing ({totalRows}) results </div>

                    {
                        (() => {
                            if (totalRows && totalRows > 0) {
                                return (
                                    projectAsset.map(post => {

                                        return (
                                            <div className='ws-12 pt border-bottom pl'>
                                                <label className='pull-left ws-3 pl'>({post.code})</label>

                                                <div className='pull-left ws-6 '>
                                                    <label className='pull-left ws-12 text-bold'>{post.name}</label>


                                                    <p className='ws-12 pull-left'>{param.showtab == 1 ? post.contractArtistDisplay : param.showtab == 2 ?
                                                        post.trackArtistDisplay : param.showtab == 4 ? post.releaseArtistName : param.showtab == 2 ? post.trackArtistDisplay : ""} </p>

                                                </div>

                                                <a className="pull-right icon-btn edit btn-xs">
                                                    <a className='pull-left p1' onClick={() => { toLinked(post, 1); getAssetList(); }}>
                                                        <TooltipList text={"Link " + (param.showtab == 1 ? "Contract" : param.showtab == 2 ? "track" : param.showtab == 3 ? "Song" : "Release")}><i className="icon-file-add"></i></TooltipList></a>
                                                    <span className={param.showtab == 1 ? 'p1' : "hide"}> | </span>
                                                    <a className={param.showtab == 1 ? 'pull-right p1' : "hide"} onClick={() => { toLinked(post, 2); getAssetList(); }}>
                                                        <TooltipList text={"Link contract"}><i className="icon-user-add"></i></TooltipList>
                                                    </a>
                                                </a>

                                            </div>
                                        );

                                    })
                                )
                            } else {
                                return <div className='pLarge mlxl'> <div className="alert alert-info ws-10 "> No data to display</div></div>
                            }
                        })()
                    }

                    <div className="ws-12">
                        {
                            (() => {
                                if (totalRows && totalRows > 10) {
                                    return  <Pagination onChange={handleNameOnChange} totalRow={totalRows} />
                                }
                            })()
                        }
                    </div>

                    <div className="box-footer alignBottom">
                        <button className="icon-btn delete pull-right"
                            onClick={() => (toggleDrawer())}>Close</button>
                    </div>

                    <div className="box-footer alignBottom hide">
                        <a className='icon-btn edit pull-right btn-xs mb"'>  <i className='icon-youtube border-right text-xl'></i> </a>
                    </div>

                </>
            </Drawer>
        </>
    )
}